export enum FileStateEnum
{
	None = 0,
	Started = 1,
	Succeed = 2,
	Faulted = 3,
	Waiting = 4
}
